import { render, staticRenderFns } from "./offline.vue?vue&type=template&id=2db0be40&scoped=true"
import script from "./offline.vue?vue&type=script&lang=js"
export * from "./offline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db0be40",
  null
  
)

export default component.exports